import { createRoute, redirect } from '@tanstack/react-router';
import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { TagIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';
import { LabelingPage } from './LabelingPage';
import { labelingSearchSchema } from './search';
import { legacyLabelingModeTarget } from '../849-review/reviewView';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/labeling',
  staticData: {
    app: {
      nav: {
        label: msg('849 Labeling', {
          context: 'sidebar nav label, Ship and Debit section',
        }),
        icon: <TagIcon className="h-4 w-4" weight="fill" />,
        group: 'Ship and Debit',
        order: 26,
      },
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SD849Response },
        ],
      },
    },
  },
  component: LabelingPage,
  loader: () => ({
    crumb: msg('849 Labeling', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context, search }) => {
    // The Review, Matches and Claim aging modes moved to the review page (#7656).
    const moved = legacyLabelingModeTarget({
      mode: search.mode,
      emailId: search.emailId,
    });
    if (moved)
      throw redirect({ to: '/ship-and-debit/849-review', search: moved });
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SD849Response,
    });
  },
  validateSearch: labelingSearchSchema,
});
